<template>

    <span
        class="ml2"
        data-toggle="tooltip"
        :data-placement="placement"
        :title="text"
        style="font-size: 18px;"
    >
        <i class="fa fa-question-circle"></i>
    </span>
</template>

<script>
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

export default {
    name: 'tooltip-question',

    props: {
        text: {
            type: String,
            required: true,
        },
        placement: {
            type: String,
            default: 'top',
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/TooltipQuestion.vue